import { render } from "./noShare.vue?vue&type=template&id=1f658774"
import script from "./noShare.vue?vue&type=script&lang=js"
export * from "./noShare.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__